export const THEME_MODE_LS_KEY = 'THEME_MODE';
export const RECENT_ENTITY_ACTIVITY_LS_KEY = 'RECENT_ENTITY_ACTIVITY';
